import { render, staticRenderFns } from "./TrainingModuleVersionThree.vue?vue&type=template&id=b5a35ee0&scoped=true&"
import script from "./TrainingModuleVersionThree.vue?vue&type=script&lang=js&"
export * from "./TrainingModuleVersionThree.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModuleVersionThree.vue?vue&type=style&index=0&id=b5a35ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a35ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
